import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-professional-bodies-bp.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-professional-bodies-bp.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { ActivatedRoute } from "@angular/router";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { ViewApplicationService } from "../../../view-application.service";
import { ViewApplicationProfessionalBodiesBpConstants } from "./view-application-professional-bodies-bp.constants";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { AlertType } from "../../../../../shared/models/alert";
import { AppControllerService } from "../../../../../app-controller.service";
import { RecipientSelectService } from "../../../../../shared/components/recipient-select/shared/service/recipient-select.service";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import RecipientUtils from "../../../../../shared/utils/recipient-utils";
import { BuildingPlansService } from "../../../../../shared/services/modules/building-plans.service";
import { take, takeUntil } from "rxjs/operators";
let ViewApplicationProfessionalBodiesBpComponent = class ViewApplicationProfessionalBodiesBpComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    route;
    routerParamsService;
    viewApplicationService;
    appController;
    recipientSelectService;
    buildingPlansService;
    changeDetectorRefs;
    professionalBodiesForm;
    saveBtnPlaceholder = ViewApplicationProfessionalBodiesBpConstants.SAVE_BUTTON_PLACEHOLDER;
    markArchitectAsNotApplicableLabel = ViewApplicationProfessionalBodiesBpConstants.MARK_ARCHITECT_AS_NOT_APPLICABLE_LABEL;
    markArchitectAsNotApplicableFormControlName = ViewApplicationProfessionalBodiesBpConstants.MARK_ARCHITECT_AS_NOT_APPLICABLE_FORM_CONTROL_NAME;
    copyApplicantToArchitectDetailsFormControlName = ViewApplicationProfessionalBodiesBpConstants.COPY_APPLICANT_DETAILS_TO_ARCHITECT_FORM_CONTROL_NAME;
    copyApplicantDetailsToArchitectLabel = ViewApplicationProfessionalBodiesBpConstants.COPY_APPLICANT_DETAILS_TO_ARCHITECT_LABEL;
    markEngineerAsNotApplicableLabel = ViewApplicationProfessionalBodiesBpConstants.MARK_ENGINEER_AS_NOT_APPLICABLE_LABEL;
    markEngineerAsNotApplicableFormControlName = ViewApplicationProfessionalBodiesBpConstants.MARK_ENGINEER_AS_NOT_APPLICABLE_FORM_CONTROL_NAME;
    copyApplicantDetailsToEngineerFormControlName = ViewApplicationProfessionalBodiesBpConstants.COPY_APPLICANT_DETAILS_TO_ENGINEER_FORM_CONTROL_NAME;
    copyApplicantDetailsToEngineerLabel = ViewApplicationProfessionalBodiesBpConstants.COPY_APPLICANT_DETAILS_TO_ENGINEER_LABEL;
    markElectricalContractorAsNotApplicableLabel = ViewApplicationProfessionalBodiesBpConstants.MARK_ELECTRICAL_CONTRACTOR_AS_NOT_APPLICABLE_LABEL;
    markElectricalContractorAsNotApplicableFormControlName = ViewApplicationProfessionalBodiesBpConstants.MARK_ELECTRICAL_CONTRACTOR_AS_NOT_APPLICABLE_FORM_CONTROL_NAME;
    copyApplicantDetailsToElectricalContractorFormControlName = ViewApplicationProfessionalBodiesBpConstants.COPY_APPLICANT_DETAILS_TO_ELECTRICAL_CONTRACTOR_FORM_CONTROL_NAME;
    copyApplicantDetailsToElectricalContractorLabel = ViewApplicationProfessionalBodiesBpConstants.COPY_APPLICANT_DETAILS_TO_ELECTRICAL_CONTRACTOR_LABEL;
    markFireConsultantAsNotApplicableLabel = ViewApplicationProfessionalBodiesBpConstants.MARK_FIRE_CONSULTANT_AS_NOT_APPLICABLE_LABEL;
    markFireConsultantAsNotApplicableFormControlName = ViewApplicationProfessionalBodiesBpConstants.MARK_FIRE_CONSULTANT_AS_NOT_APPLICABLE_FORM_CONTROL_NAME;
    copyApplicantDetailsToFireConsultantFormControlName = ViewApplicationProfessionalBodiesBpConstants.COPY_APPLICANT_DETAILS_TO_FIRE_CONSULTANT_FORM_CONTROL_NAME;
    copyApplicantDetailsToFireConsultantLabel = ViewApplicationProfessionalBodiesBpConstants.COPY_APPLICANT_DETAILS_TO_FIRE_CONSULTANT_LABEL;
    markOtherProfessionalAsNotApplicableLabel = ViewApplicationProfessionalBodiesBpConstants.MARK_OTHER_PROFESSIONAL_AS_NOT_APPLICABLE_LABEL;
    markOtherProfessionalAsNotApplicableFormControlName = ViewApplicationProfessionalBodiesBpConstants.MARK_OTHER_PROFESSIONAL_AS_NOT_APPLICABLE_FORM_CONTROL_NAME;
    copyApplicantDetailsToOtherProfessionalFormControlName = ViewApplicationProfessionalBodiesBpConstants.COPY_APPLICANT_DETAILS_TO_OTHER_PROFESSIONAL_FORM_CONTROL_NAME;
    copyApplicantDetailsToOtherProfessionalLabel = ViewApplicationProfessionalBodiesBpConstants.COPY_APPLICANT_DETAILS_TO_OTHER_PROFESSIONAL_LABEL;
    architectFormControlName = ViewApplicationProfessionalBodiesBpConstants.ARCHITECT_FORM_CONTROL_NAME;
    engineerFormControlName = ViewApplicationProfessionalBodiesBpConstants.ENGINEER_FORM_CONTROL_NAME;
    contractorFormControlName = ViewApplicationProfessionalBodiesBpConstants.ELECTRICAL_CONTRACTOR_FORM_CONTROL_NAME;
    fireConsultantFormControlName = ViewApplicationProfessionalBodiesBpConstants.FIRE_CONSULTANT_FORM_CONTROL_NAME;
    otherProfessionalFormControlName = ViewApplicationProfessionalBodiesBpConstants.OTHER_PROFESSIONAL_FORM_CONTROL_NAME;
    showArchitect = false;
    showEngineer = false;
    showElectricalContractor = false;
    showFireConsultant = false;
    showOtherProfessional = false;
    architectDisableFilterBy = true;
    architectDisableAdd = true;
    architectDisableEditing = false;
    architectShowFields = true;
    architectIsInternal = false;
    architectGroups = [];
    architectLabel = ViewApplicationProfessionalBodiesBpConstants.ARCHITECT_LABEL;
    engineerDisableFilterBy = true;
    engineerDisableAdd = true;
    engineerDisableEditing = false;
    engineerShowFields = true;
    engineerIsInternal = false;
    engineerGroups = [];
    engineerLabel = ViewApplicationProfessionalBodiesBpConstants.ENGINEER_LABEL;
    contractorDisableFilterBy = true;
    contractorDisableAdd = true;
    contractorDisableEditing = false;
    contractorShowFields = true;
    contractorIsInternal = false;
    contractorGroups = [];
    contractorLabel = ViewApplicationProfessionalBodiesBpConstants.ELECTRICAL_CONTRACTOR_LABEL;
    fireConsultantDisableFilterBy = true;
    fireConsultantDisableAdd = true;
    fireConsultantDisableEditing = false;
    fireConsultantShowFields = true;
    fireConsultantIsInternal = false;
    fireConsultantGroups = [];
    fireConsultantLabel = ViewApplicationProfessionalBodiesBpConstants.FIRE_CONSULTANT_LABEL;
    otherProfessionalDisableFilterBy = true;
    otherProfessionalDisableAdd = true;
    otherProfessionalDisableEditing = false;
    otherProfessionalShowFields = true;
    otherProfessionalIsInternal = false;
    otherProfessionalGroups = [];
    otherProfessionalLabel = ViewApplicationProfessionalBodiesBpConstants.OTHER_PROFESSIONAL_LABEL;
    application;
    getSetProfessionalBodiesObservableSubscription;
    getStepMetaObservableSubscription;
    constructor(aflaModuleStrategyService, route, routerParamsService, viewApplicationService, appController, recipientSelectService, buildingPlansService, changeDetectorRefs) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.route = route;
        this.routerParamsService = routerParamsService;
        this.viewApplicationService = viewApplicationService;
        this.appController = appController;
        this.recipientSelectService = recipientSelectService;
        this.buildingPlansService = buildingPlansService;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.listenForRouteParamChange();
        this.initForm();
        this.getMetadata();
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    handleRouteChange() {
        // this.getMetadata();
    }
    getApplication() {
        const params = {
            $expand: `architect($expand=groups),engineer($expand=groups),electricalContractor($expand=groups),applicant($expand=groups),fireConsultant($expand=groups),otherProfessional($expand=groups)`,
            $filter: `jobId eq ${this.jobID}`,
        };
        const getApplicationObservable = this.viewApplicationService
            .getApplicationObservable(this.aflaModuleStrategyService.applicationServiceUrl, params)
            .pipe(takeUntil(this._destroy$), take(1))
            .subscribe({
            next: (response) => this.onGetApplicationCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationProfessionalBodiesBpConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onCopyApplicantDetailsToArchitectChecked(event) {
        if (event.currentTarget.checked === true) {
            this.professionalBodiesForm.get("architectRecipient").disable();
        }
        else {
            this.professionalBodiesForm.get("architectRecipient").enable();
        }
    }
    onCopyApplicantDetailsToEngineerChecked(event) {
        if (event.currentTarget.checked === true) {
            this.professionalBodiesForm.get("engineerRecipients").disable();
        }
        else {
            this.professionalBodiesForm.get("engineerRecipients").enable();
        }
    }
    onCopyApplicantDetailsToElectricalContractorChecked(event) {
        if (event.currentTarget.checked === true) {
            this.professionalBodiesForm.get("electricalContractorRecipient").disable();
        }
        else {
            this.professionalBodiesForm.get("electricalContractorRecipient").enable();
        }
    }
    onCopyApplicantDetailsToFireConsultantChecked(event) {
        if (event.currentTarget.checked === true) {
            this.professionalBodiesForm.get("fireConsultantRecipient").disable();
        }
        else {
            this.professionalBodiesForm.get("fireConsultantRecipient").enable();
        }
    }
    onCopyApplicantDetailsToOtherProfessionalChecked(event) {
        if (event.currentTarget.checked === true) {
            this.professionalBodiesForm.get("otherProfessionalRecipient").disable();
        }
        else {
            this.professionalBodiesForm.get("otherProfessionalRecipient").enable();
        }
    }
    onMarkArchitectAsNotApplicableChecked(event) {
        this.showArchitect = event.currentTarget.checked;
        if (this.showArchitect === false) {
            this.professionalBodiesForm.get("architectRecipient").disable();
            this.professionalBodiesForm.get("architectRecipient").reset();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToArchitect");
            copyControl.setValue(false);
            copyControl.disable();
        }
        else {
            this.professionalBodiesForm.get("architectRecipient").enable();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToArchitect");
            copyControl.enable();
        }
    }
    onMarkEngineerAsNotApplicableChecked(event) {
        this.showEngineer = event.currentTarget.checked;
        if (this.showEngineer === false) {
            this.professionalBodiesForm.get("engineerRecipients").disable();
            this.professionalBodiesForm.get("engineerRecipients").reset();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToEngineer");
            copyControl.setValue(false);
            copyControl.disable();
        }
        else {
            this.professionalBodiesForm.get("engineerRecipients").enable();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToEngineer");
            copyControl.enable();
        }
    }
    onMarkElectricalContractorAsNotApplicableChecked(event) {
        this.showElectricalContractor = event.currentTarget.checked;
        if (this.showElectricalContractor === false) {
            this.professionalBodiesForm.get("electricalContractorRecipient").disable();
            this.professionalBodiesForm.get("electricalContractorRecipient").reset();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToElectricalContractor");
            copyControl.setValue(false);
            copyControl.disable();
        }
        else {
            this.professionalBodiesForm.get("electricalContractorRecipient").enable();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToElectricalContractor");
            copyControl.enable();
        }
    }
    onMarkFireConsultantAsNotApplicableChecked(event) {
        this.showFireConsultant = event.currentTarget.checked;
        if (this.showFireConsultant === false) {
            this.professionalBodiesForm.get("fireConsultantRecipient").disable();
            this.professionalBodiesForm.get("fireConsultantRecipient").reset();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToFireConsultant");
            copyControl.setValue(false);
            copyControl.disable();
        }
        else {
            this.professionalBodiesForm.get("fireConsultantRecipient").enable();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToFireConsultant");
            copyControl.enable();
        }
    }
    onMarkOtherProfessionalAsNotApplicableChecked(event) {
        this.showOtherProfessional = event.currentTarget.checked;
        if (this.showOtherProfessional === false) {
            this.professionalBodiesForm.get("otherProfessionalRecipient").disable();
            this.professionalBodiesForm.get("otherProfessionalRecipient").reset();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToOtherProfessional");
            copyControl.setValue(false);
            copyControl.disable();
        }
        else {
            this.professionalBodiesForm.get("otherProfessionalRecipient").enable();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToOtherProfessional");
            copyControl.enable();
        }
    }
    onBtnSaveClicked($event) {
        if (this.professionalBodiesForm.valid) {
            const applicantFormValue = this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").value;
            let architectRecipient = null;
            const architectFormControl = this.professionalBodiesForm.get("architectRecipient");
            const copyApplicantDetailsToArchitect = this.professionalBodiesForm.get("copyApplicantDetailsToArchitect").value;
            const markArchitectAsNotApplicable = this.professionalBodiesForm.get("markArchitectAsNotApplicable").value;
            if (copyApplicantDetailsToArchitect || markArchitectAsNotApplicable) {
                if (copyApplicantDetailsToArchitect) {
                    this.recipientSelectService.setRecipient(applicantFormValue, true, architectFormControl, true);
                }
                const architectRecipientFormValue = this.professionalBodiesForm.get("architectRecipient").value;
                architectRecipient = RecipientUtils.removeRecipientProperties(architectRecipientFormValue);
            }
            let engineerRecipient = null;
            const engineerRecipientFormControl = this.professionalBodiesForm.get("engineerRecipients");
            const copyApplicantDetailsToEngineer = this.professionalBodiesForm.get("copyApplicantDetailsToEngineer").value;
            const markEngineerAsNotApplicable = this.professionalBodiesForm.get("markEngineerAsNotApplicable").value;
            if (copyApplicantDetailsToEngineer || markEngineerAsNotApplicable) {
                if (copyApplicantDetailsToEngineer) {
                    this.recipientSelectService.setRecipient(applicantFormValue, true, engineerRecipientFormControl, true);
                }
                const engineerRecipientFormValue = this.professionalBodiesForm.get("engineerRecipients").value;
                engineerRecipient = RecipientUtils.removeRecipientProperties(engineerRecipientFormValue);
            }
            let electricalContractorRecipient = null;
            const electricalContractorRecipientFormControl = this.professionalBodiesForm.get("electricalContractorRecipient");
            const copyApplicantDetailsToContractor = this.professionalBodiesForm.get("copyApplicantDetailsToElectricalContractor").value;
            const markContractorAsNotApplicable = this.professionalBodiesForm.get("markElectricalContractorAsNotApplicable").value;
            if (markContractorAsNotApplicable || copyApplicantDetailsToContractor) {
                if (copyApplicantDetailsToContractor) {
                    this.recipientSelectService.setRecipient(applicantFormValue, true, electricalContractorRecipientFormControl, true);
                }
                const electricalContractorRecipientFormValue = this.professionalBodiesForm.get("electricalContractorRecipient").value;
                electricalContractorRecipient = RecipientUtils.removeRecipientProperties(electricalContractorRecipientFormValue);
            }
            let fireConsultantRecipient = null;
            const fireConsultantFormControl = this.professionalBodiesForm.get("fireConsultantRecipient");
            const copyApplicantDetailsToFireConsultant = this.professionalBodiesForm.get("copyApplicantDetailsToFireConsultant").value;
            const markFireConsultantAsNotApplicable = this.professionalBodiesForm.get("markFireConsultantAsNotApplicable").value;
            if (copyApplicantDetailsToFireConsultant || markFireConsultantAsNotApplicable) {
                if (copyApplicantDetailsToFireConsultant) {
                    this.recipientSelectService.setRecipient(applicantFormValue, true, fireConsultantFormControl, true);
                }
                const fireConsultantRecipientFormValue = this.professionalBodiesForm.get("fireConsultantRecipient").value;
                fireConsultantRecipient = RecipientUtils.removeRecipientProperties(fireConsultantRecipientFormValue);
            }
            let otherProfessionalRecipient = null;
            const otherProfessionalFormControl = this.professionalBodiesForm.get("otherProfessionalRecipient");
            const copyApplicantDetailsToOtherProfessional = this.professionalBodiesForm.get("copyApplicantDetailsToOtherProfessional").value;
            const markOtherProfessionalAsNotApplicable = this.professionalBodiesForm.get("markOtherProfessionalAsNotApplicable").value;
            if (copyApplicantDetailsToOtherProfessional || markOtherProfessionalAsNotApplicable) {
                if (copyApplicantDetailsToOtherProfessional) {
                    this.recipientSelectService.setRecipient(applicantFormValue, true, otherProfessionalFormControl, true);
                }
                const otherProfessionalRecipientFormValue = this.professionalBodiesForm.get("otherProfessionalRecipient").value;
                otherProfessionalRecipient = RecipientUtils.removeRecipientProperties(otherProfessionalRecipientFormValue);
            }
            const request = {
                architect: architectRecipient,
                engineer: engineerRecipient,
                electricalContractor: electricalContractorRecipient,
                fireConsultant: fireConsultantRecipient,
                otherProfessional: otherProfessionalRecipient
            };
            this.getSetProfessionalBodiesObservableSubscription =
                this.buildingPlansService.getSetProfessionalBodiesObservable(this.application.id, request)
                    .subscribe({
                    next: response => {
                        this.getApplication();
                    },
                    error: error => {
                        this.appController.handleServerErrorMessage(ViewApplicationProfessionalBodiesBpConstants.STEP_TITLE, error, CRUDOperation.Update);
                    }
                });
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("professionalBodiesForm");
        this.professionalBodiesForm = form;
    }
    getMetadata() {
        const filterString = `stepName eq \'Start\' AND moduleId eq ${this.moduleID}`;
        const params = {
            $filter: filterString
        };
        this.getStepMetaObservableSubscription = this.viewApplicationService.getStepMetaObservable(params).subscribe((metadata) => {
            this.loadMetadata(JSON.parse(metadata.value[0].metadata));
        });
    }
    loadMetadata(stepMeta) {
        try {
            this.architectGroups = this.recipientSelectService.checkStepMetaRecipientGroups(stepMeta.architectGroup);
            this.engineerGroups = this.recipientSelectService.checkStepMetaRecipientGroups(stepMeta.engineerGroup);
            this.contractorGroups = this.recipientSelectService.checkStepMetaRecipientGroups(stepMeta.electricalContractorGroup);
            this.fireConsultantGroups = this.recipientSelectService.checkStepMetaRecipientGroups(stepMeta.fireConsultantGroup);
            this.otherProfessionalGroups = this.recipientSelectService.checkStepMetaRecipientGroups(stepMeta.otherProfessionalGroup);
        }
        catch (e) {
            this.appController.showMessage(SharedConstants.INVALID_METADATA, AlertType.Error);
        }
        this.getApplication();
    }
    onGetApplicationCompleted(response) {
        if (response && response.value.length > 0) {
            this.professionalBodiesForm.reset();
            const application = response.value[0];
            this.application = application;
            this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").setValue(this.application.applicant[0]);
            if (this.application.architect.length > 0) {
                this.showArchitect = true;
                const recipientControl = this.professionalBodiesForm.get("architectRecipient");
                recipientControl.enable();
                recipientControl.setValue(this.application.architect[0]);
                this.professionalBodiesForm.get("markArchitectAsNotApplicable").setValue(true);
                const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToArchitect");
                copyControl.setValue(false);
                copyControl.enable();
            }
            else {
                this.showArchitect = false;
                this.professionalBodiesForm.get("markArchitectAsNotApplicable").setValue(false);
                const recipientControl = this.professionalBodiesForm.get("architectRecipient");
                recipientControl.disable();
                const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToArchitect");
                copyControl.setValue(false);
                copyControl.disable();
            }
            if (this.application.engineer.length > 0) {
                this.showEngineer = true;
                const recipientControl = this.professionalBodiesForm.get("engineerRecipients");
                recipientControl.enable();
                recipientControl.setValue(this.application.engineer[0]);
                this.professionalBodiesForm.get("markEngineerAsNotApplicable").setValue(true);
                const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToEngineer");
                copyControl.setValue(false);
                copyControl.enable();
            }
            else {
                this.showEngineer = false;
                this.professionalBodiesForm.get("markEngineerAsNotApplicable").setValue(false);
                const recipientControl = this.professionalBodiesForm.get("engineerRecipients");
                recipientControl.disable();
                const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToEngineer");
                copyControl.setValue(false);
                copyControl.disable();
            }
            if (this.application.electricalContractor.length > 0) {
                this.showElectricalContractor = true;
                const recipientControl = this.professionalBodiesForm.get("electricalContractorRecipient");
                recipientControl.enable();
                recipientControl.setValue(this.application.electricalContractor[0]);
                this.professionalBodiesForm.get("markElectricalContractorAsNotApplicable").setValue(true);
                const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToElectricalContractor");
                copyControl.setValue(false);
                copyControl.enable();
            }
            else {
                this.showElectricalContractor = false;
                this.professionalBodiesForm.get("markElectricalContractorAsNotApplicable").setValue(false);
                const recipientControl = this.professionalBodiesForm.get("electricalContractorRecipient");
                recipientControl.disable();
                const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToElectricalContractor");
                copyControl.setValue(false);
                copyControl.disable();
            }
            if (this.application.fireConsultant.length > 0) {
                this.showFireConsultant = true;
                const recipientControl = this.professionalBodiesForm.get("fireConsultantRecipient");
                recipientControl.enable();
                recipientControl.setValue(this.application.fireConsultant[0]);
                this.professionalBodiesForm.get("markFireConsultantAsNotApplicable").setValue(true);
                const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToFireConsultant");
                copyControl.setValue(false);
                copyControl.enable();
            }
            else {
                this.showFireConsultant = false;
                this.professionalBodiesForm.get("markFireConsultantAsNotApplicable").setValue(false);
                const recipientControl = this.professionalBodiesForm.get("fireConsultantRecipient");
                recipientControl.disable();
                const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToFireConsultant");
                copyControl.setValue(false);
                copyControl.disable();
            }
            if (this.application.otherProfessional.length > 0) {
                this.showOtherProfessional = true;
                const recipientControl = this.professionalBodiesForm.get("otherProfessionalRecipient");
                recipientControl.enable();
                recipientControl.setValue(this.application.otherProfessional[0]);
                this.professionalBodiesForm.get("markOtherProfessionalAsNotApplicable").setValue(true);
                const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToOtherProfessional");
                copyControl.setValue(false);
                copyControl.enable();
            }
            else {
                this.showOtherProfessional = false;
                this.professionalBodiesForm.get("markOtherProfessionalAsNotApplicable").setValue(false);
                const recipientControl = this.professionalBodiesForm.get("otherProfessionalRecipient");
                recipientControl.disable();
                const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToOtherProfessional");
                copyControl.setValue(false);
                copyControl.disable();
            }
        }
        this.changeDetectorRefs.detectChanges();
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ActivatedRoute },
        { type: RouterParamsService },
        { type: ViewApplicationService },
        { type: AppControllerService },
        { type: RecipientSelectService },
        { type: BuildingPlansService },
        { type: ChangeDetectorRef }
    ];
};
ViewApplicationProfessionalBodiesBpComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-view-application-professional-bodies-bp",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationProfessionalBodiesBpComponent);
export { ViewApplicationProfessionalBodiesBpComponent };
